import request from '../../shared/request'

export function getOrganizationsList() {
  return request('/organization')
}

export function createNewOrganization(payload) {
  return request(`/organization/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/organization.js